import { render, staticRenderFns } from "./AddAvb.vue?vue&type=template&id=69914355"
import script from "./AddAvb.vue?vue&type=script&lang=js"
export * from "./AddAvb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports